import { SCENARIO_TYPES } from '@/constants/scenarios';
import { z } from 'zod';

export const getCommonSchema = (t: any) =>
  z.object({
    vendorIdList: z.array(z.string()).min(1, t('onboarding.fields.errors.selectOrigin', 'Select origin')),
    partnerMargin: z
      .number({
        message: t('onboarding.fields.errors.validMargin', 'Enter a valid margin'),
      })
      .min(0)
      .max(100),
    invoicingAmount: z
      .number({
        message: t('onboarding.fields.errors.validAmount', 'Enter a valid amount'),
      })
      .positive(t('onboarding.fields.errors.validAmount', 'Enter a valid amount')),
    scenario: z.enum(SCENARIO_TYPES),
  });
export type CommonFormValues = z.infer<ReturnType<typeof getCommonSchema>>;
